// Response order and the amount of traffic must not decide the language order.
export function articleLocaleOrder(a:{locale?:string;key:string},b:{locale?:string;key:string}){
 const rank=(locale?:string)=>locale?.toLowerCase()==='da'?0:locale?.toLowerCase()==='en'?1:2;
 return rank(a.locale)-rank(b.locale)||(a.locale||'').localeCompare(b.locale||'')||a.key.localeCompare(b.key);
}
